import { render, staticRenderFns } from "./FancyDecimal.vue?vue&type=template&id=22edbfce&scoped=true&"
import script from "./FancyDecimal.vue?vue&type=script&lang=js&"
export * from "./FancyDecimal.vue?vue&type=script&lang=js&"
import style0 from "./FancyDecimal.vue?vue&type=style&index=0&id=22edbfce&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22edbfce",
  null
  
)

export default component.exports